export default __webpack_public_path__ + "media/images/react_icons/globe-white-f442f65e7fd1039942c7047305128497.svg";